import { NgModule } from '@angular/core';
import { ResizeColumnsDirective } from './resize-columns.directive';

export function customDirectives() {
  return [ResizeColumnsDirective];
}

@NgModule({
  declarations: customDirectives(),
  exports: customDirectives(),
})
export class CustomDirectivesModule {}
